import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button, Card, EmptyState } from '@/components/ui';

export function NotFoundPage() {
  return (
    <Card>
      <EmptyState
        icon={<Compass className="h-6 w-6" />}
        title="Page not found"
        description="The page you’re looking for doesn’t exist or has moved."
        action={
          <Link to="/inbox">
            <Button variant="secondary">Back to inbox</Button>
          </Link>
        }
      />
    </Card>
  );
}
